<template>
  <div class="w-100">
    <item v-for="item in items" :key="item.id" :item="item"></item>
  </div>
</template>

<script>
import Item from "./item";

export default {
  components: {
    Item,
  },

  props: {
    items: Array,
  },
}
</script>

<style scoped>

</style>
